import React from "react"

const EmptyBlocksState: React.FC = () => (
  <div className="text-center py-8">
    <p className="text-palette-jungleGreen500">No trial blocks found for the selected filters.</p>
  </div>
)

export default EmptyBlocksState
